export default __webpack_public_path__ + "static/media/treinamentos-4.af42ef37.png";